<!--
 * @Author: 王枫叶
-->
<!-- 本书配置 -->
<template>
  <div class="config-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
       width="810px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          class="checkAll"
          >全选</el-checkbox
        >
        <el-button type="success"  size="small" @click="updatePrice()">本书一键配置</el-button>
      </div>
      <el-checkbox-group
        v-model="checkedepisodeNumbers"
        @change="handleCheckedCitiesChange"
        class="checkboxGroup"
        text-color="#FFFFFF"
      >
        <el-checkbox-button
          v-for="item in episodeNumbers"
          :label="item"
          :key="item"
          class="checkbox"
          >{{ '第' + item + '集' }}
          </el-checkbox-button
        >
      </el-checkbox-group>
      <editPrice
        ref="editPrice"
        :params_detail="params_detail"
        :checkedepisodeNumbers="checkedepisodeNumbers"
        v-on="$listeners"
      ></editPrice>
    </el-dialog>
  </div>
</template>
<script>
import editPrice from './components/editPrice'

export default {
  data() {
    return {
      type: '',
      dialogVisible: false,
      params_detail: {},//本书对象
      title: '',
      prices: [],//每集价格集合
      price: '',//单集价格

      checkAll: false,
      checkedepisodeNumbers: [],//已勾选章节
      episodeNumbers: [],  //总章节数
      isIndeterminate:undefined //是否展示不确定状态
    }
  },
  components: {
    editPrice
  },
  methods: {
    // 全选
    handleCheckAllChange(val) {
      //全选操作：要么全部选中(ture)，要么都不选中(false)，所以始终不会出现不确定状态
      this.checkedepisodeNumbers = val ? this.episodeNumbers : [];
      this.isIndeterminate = false;
    },
    // 单选
    handleCheckedCitiesChange(value) {     
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.episodeNumbers.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.episodeNumbers.length;
    },
    // 本书配置    
    updatePrice(price) {
      if (this.prices.length === 1) {
        price = this.prices[0]
      }
      this.$refs.editPrice.open(price)
    },
    // 关闭详情弹窗
    handleClose() {
      this.dialogVisible = false
    },
    // 打开详情弹窗
    open(data) {
      this.episodeNumbers = data.contentSet.map(el => el.episodeNumber)
      this.prices = data.contentSet.map(el => el.price)
      this.dialogVisible = true
      this.params_detail = data
      this.title = '本书配置'
    },
  },
}
</script>

<style lang="scss" scoped>
.config-box {
 .checkAll{
   margin-bottom: 30px; margin-right: 20px
 }
 .checkboxGroup{
   max-height:500px;
   overflow: auto;
   border:1px solid #000;padding:20px 10px;
 }
.checkboxGroup .checkbox{
  padding: 2px;
  margin-bottom: 4px;
  margin:6px 10px ;
  
}
}
</style>
<style>
.el-checkbox-button__inner {
    width: 80px;
    border:none !important;
    border: 1px solid #DCDFE6 !important;
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
    color: #FFFFFF;
    background-color: #6e73bb !important;
    border-color: #8389b8 !important;
    border-radius: 2px;
}
</style>